import { fetchGet, fetchPost } from './fetch';
import { GenerateReimagineParams } from './interface';
import { Audio2AudioInputParams, AudioDto, AudioRefinerInputParams, ContinueAudioInputParams, GenerateAudioInputParams } from './type';

export type GeneratorResponseDTO = {
  data?: AudioDto[];
  creditBalance: number;
  error?: {
    errorMessage: string;
    errorCode: string;
    statusCode: number;
    timestamp: string;
  };
};
type SingleGeneratorResponseDTO = {
  data?: AudioDto;
  error?: {
    errorMessage: string;
    code: number;
  };
};

interface StylefilterResponseDTO {
  data?: {
    id: string;
    name: string;
  }[];
}

interface AudioUploadForTrimParams {
  file: Blob; // binary data
  type: 'mp3' | 'wav';
  startTime: number; // milliseconds
  endTime: number; // milliseconds
  audioId: string;
}
const API_URL = '/api/v1/audio';

export const postAudioGenerate = async (req: GenerateAudioInputParams): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/generate_jenxl`;
  return fetchPost<GenerateAudioInputParams, GeneratorResponseDTO>(url, req);
};

export const postAudioGenerateReimagine = async (req: GenerateReimagineParams): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/generate_reimagine`;
  return fetchPost<GenerateReimagineParams, GeneratorResponseDTO>(url, req);
};

export const postAudioContinue = async (id: string, req: ContinueAudioInputParams): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/continuation/${id}`;
  return fetchPost<ContinueAudioInputParams, GeneratorResponseDTO>(url, req);
};

export const postAudioUpload = async (req: FormData): Promise<SingleGeneratorResponseDTO> => {
  const url = `${API_URL}/upload_audio`;
  return fetchPost<FormData, SingleGeneratorResponseDTO>(url, req);
};

export const postAudio2Audio = async (id: string, req: Audio2AudioInputParams): Promise<SingleGeneratorResponseDTO> => {
  const url = `${API_URL}/audio2audio/${id}`;
  return fetchPost<Audio2AudioInputParams, SingleGeneratorResponseDTO>(url, req);
};

export const postAudioRefiner = async (id: string, req: AudioRefinerInputParams): Promise<GeneratorResponseDTO> => {
  const url = `${API_URL}/audio_refiner/${id}`;
  return fetchPost<AudioRefinerInputParams, GeneratorResponseDTO>(url, req);
};

export const getStyleFilterList = async (): Promise<StylefilterResponseDTO> => {
  const url = `/api/v1/stylefilter/list`;
  return fetchGet<StylefilterResponseDTO>(url);
};

export const getAllStyleFilterList = async (): Promise<StylefilterResponseDTO> => {
  const url = `/api/v2/stylefilter/public_list`;
  return fetchGet<StylefilterResponseDTO>(url);
};

export const postAudioUploadForTrim = async (req: FormData): Promise<GeneratorResponseDTO> => {
  const url = `/api/v2/audio/upload_audio_for_trim`;
  return fetchPost<FormData, GeneratorResponseDTO>(url, req);
};
